import { Card } from "~/features/configurator/Linear/components/Card";
import { Button, styled } from "~/common/mui";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { Dialog, DialogTitle } from "~/common/mui/Dialog/Dialog";
import { LinkButton } from "~/common/components/Link";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_TABLET } from "~/common/utils/screenSizes";
import { C_OUTLINE_VARIANT } from "~/common/components/icon/Colors";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";

interface CadSurveyProps {
  bearingDesignation: string;
}

const StyledDialogTitle = styled(DialogTitle)({
  display: "flex",
  justifyContent: "end",
  padding: "12px 24px",
  borderBottom: `1px solid ${C_OUTLINE_VARIANT}`,
  [`@media ${MEDIA_QUERY_MIN_TABLET}`]: {
    border: "0",
  },
});

const StyledIFrame = styled("iframe")({
  width: "100%",
  height: "100%",
  border: "0",
});

const StyledCard = styled(Card)({
  marginTop: "20px",
  padding: "32px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

const CadSurvey = ({ bearingDesignation }: CadSurveyProps) => {
  const { val: modal, setTrue: openModal, setFalse: closeModal } = useBooleanState(false);
  const { t } = useTranslation();
  const isTablet = useIsMinTabletSize();

  const cadSurveyUrl = `https://schaefflertech.qualtrics.com/jfe/form/SV_1TynSPJggPrEOeq?bearingDesignation=${bearingDesignation}&Q_Language=${
    window.__SCHA_BOOT__?.language ?? ""
  }`;

  return (
    <>
      <Dialog
        fullWidth
        fullScreen={!isTablet}
        PaperProps={{
          sx: {
            height: "100%",
            // This is the same max-width that is used for large size modals
            maxWidth: "992px",
          },
        }}
        open={modal}
        onClose={closeModal}
      >
        <StyledDialogTitle>
          <LinkButton type="button" onClick={closeModal}>
            <CloseIcon />
          </LinkButton>
        </StyledDialogTitle>
        <StyledIFrame src={cadSurveyUrl} />
      </Dialog>
      <StyledCard>
        <span className="f-15 f-bold">{t("cadDownload.feedback.title")}</span>
        <span className="f-15 ">{t("cadDownload.feedback.message")}</span>
        <Button color="secondary" onClick={openModal}>
          {t("cadDownload.feedback.button")}
        </Button>
      </StyledCard>
    </>
  );
};

export default CadSurvey;
